import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

import InputUtils from 'helpers/inputUtils';

const inputUtils = new InputUtils();

// Create styles
const styles = StyleSheet.create({
  page: {
    padding: 40,
    backgroundColor: 'white',
  },
  title: {
    fontSize: 20,
    textAlign: 'center',
    color: 'red',
    marginBottom: 10,
  },
  subtitle: {
    fontSize: 10,
    textAlign: 'center',
    marginBottom: 15,
  },
  table: {
    width: '100%',
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#808080',
    padding: 5,
  },
  tableHeaderCell: {
    color: 'white',
    fontSize: 9,
    fontWeight: 'bold',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
    padding: 5,
    backgroundColor: 'white',
  },
  tableRowAlt: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
    padding: 5,
    backgroundColor: '#f9f9f9',
  },
  unitColumn: {
    flex: 1,
    fontSize: 9,
  },
  yearColumn: {
    flex: 1,
    fontSize: 9,
  },
  makeModelColumn: {
    flex: 2,
    fontSize: 9,
  },
  vinColumn: {
    flex: 2,
    fontSize: 9,
  },
  bodyTypeColumn: {
    flex: 1,
    fontSize: 9,
  },
  ownColumn: {
    flex: 1,
    fontSize: 9,
  },
});

const TrailersSchedule = ({ trailers }) => {
  return (
    <>
      <Text style={styles.title}>Trailer Schedule</Text>
      <Text style={styles.subtitle}>
        It is hereby noted and agreed that only the Trailer(s)
        specified in the schedule will be covered:
      </Text>

      <View style={styles.table}>
        <View style={styles.tableHeader}>
          <Text style={[styles.tableHeaderCell, styles.unitColumn]}>
            Unit #
          </Text>
          <Text style={[styles.tableHeaderCell, styles.yearColumn]}>
            Year
          </Text>
          <Text
            style={[styles.tableHeaderCell, styles.makeModelColumn]}
          >
            Make/Model
          </Text>
          <Text style={[styles.tableHeaderCell, styles.vinColumn]}>
            VIN
          </Text>
          <Text
            style={[styles.tableHeaderCell, styles.bodyTypeColumn]}
          >
            Body Type
          </Text>
          <Text style={[styles.tableHeaderCell, styles.ownColumn]}>
            Own/Non-Own
          </Text>
        </View>

        {(!trailers || trailers?.length === 0) && (
          <View>
            <Text
              style={{
                width: '100%',
                padding: 5,
                textAlign: 'center',
                fontSize: 10,
              }}
            >
              No trailers found
            </Text>
          </View>
        )}

        {trailers?.map((trailer, index) => (
          <View
            key={index}
            style={
              index % 2 === 0 ? styles.tableRow : styles.tableRowAlt
            }
          >
            <Text style={styles.unitColumn}>{index}</Text>
            <Text style={styles.yearColumn}>{trailer.year}</Text>
            <Text style={styles.makeModelColumn}>
              {trailer.make} {trailer.model}
            </Text>
            <Text style={styles.vinColumn}>{trailer.vin}</Text>
            <Text style={styles.bodyTypeColumn}>
              {inputUtils.capitalizeFirstLetter(
                trailer?.bodyTypeKey?.replaceAll('_', ' ')
              )}
            </Text>
            <Text style={styles.ownColumn}>Own</Text>
          </View>
        ))}
      </View>
    </>
  );
};

export default TrailersSchedule;
